import { useEffect, useRef } from 'react'

const TroopodEvent = ({ elemRef }: any) => {
  const prevProductIdRef = useRef<string | null>(null)

  useEffect(() => {
    const currentElem = elemRef.current

    if (currentElem) {
      const currentProductId = currentElem.getAttribute('data-productId')
      const hasProductIdChanged = currentProductId !== null && prevProductIdRef.current !== currentProductId
      if (hasProductIdChanged || prevProductIdRef.current === null) {
        const event = new Event('statechange')
        window.dispatchEvent(event)
        prevProductIdRef.current = currentProductId
      }
    }
  }, [elemRef])

  return null
}

export default TroopodEvent
